import { useMemo } from 'react';
import { CustomVizHookResult } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const useCustomVizStatus = ({
  vizInProgress,
  isLoadingDropdownOptions,
  staleResult,
}: {
  vizInProgress: boolean;
  isLoadingDropdownOptions: boolean;
  staleResult: CustomVizHookResult;
}) => {
  return useMemo(() => {
    return vizInProgress
      ? staleResult.resultType !== 'err' && staleResult.value !== null
        ? 'loading-viz-with-stale-result'
        : 'loading-viz'
      : isLoadingDropdownOptions
        ? 'loading-dropdowns'
        : 'waiting-for-user';
  }, [vizInProgress, isLoadingDropdownOptions, staleResult]);
};
